import React from "react";
import {
  services10,
  services5,
  servicesRight,
  servicesRightHover,
  services15,
  services16,
  consultancy,
  insulation,
} from "../../../assets/images";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const servicesData = [
    {
      img: services16,
      title: "Directional Drilling",
      link: "services/directional",
    },
    {
      img: services15,
      title: "IPM/ISM",
      link: "services/ipm",
    },
    {
      img: services10,
      title:
        "Geological Intelligence for Drilling: Powered by Advanced Software",
      link: "services/geological",
    },
    {
      img: services5,
      title: "Resato High Pressure Technology",
      link: "services/resato",
    },
    {
      img: insulation,
      title: "Industrial Insulation Services",
      link: "industrial/services/industrial",
    },
    {
      img: consultancy,
      title: "Consultancy Services",
      link: "industrial/services/consultancy",
    },
  ];

  return (
    <div className="bg-[#EDEDED] pt-10 md:pt-20">
      <div className="max-w-containerSm md:max-w-container mx-auto">
        <div className="text-center">
          <p className="text-[#B31F11] text-[14px] font-medium">OUR SERVICES</p>
          <p className="text-[#141615] font-firstFont text-[28px] md:text-[44px] font-bold">
            What We Do
          </p>
        </div>
        <div className="md:flex justify-between mt-6 md:mt-10">
          <div className="w-full flex justify-between items-center mt-6 md:mt-0">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
              {servicesData.map((service, index) => (
                <div key={index} className="md:w-[371px] w-full">
                  <div className="relative">
                    <img
                      src={service.img}
                      alt={service.title}
                      className="w-full rounded-t-[4px] md:h-[192px] h-[218px] object-cover"
                    />
                    <div className="absolute bottom-2 left-5 right-5 font-medium text-[#222] bg-white bg-opacity-80 px-2 py-1 rounded">
                      <p className="opacity-90">{service.title}</p>
                    </div>
                  </div>
                  <a
                    href={`/${currentLanguage}/${service.link}`}
                    className="group"
                  >
                    <div className="h-[44px] w-full px-5 flex justify-between items-center bg-white group-hover:bg-[#B31F11] transition-colors duration-300">
                      <p className="text-black group-hover:text-white">
                        More Info
                      </p>
                      <div className="relative w-6 h-6">
                        <img
                          src={servicesRight}
                          alt="arrow icon"
                          className="absolute inset-0 w-full h-full group-hover:hidden"
                        />
                        <img
                          src={servicesRightHover}
                          alt="arrow icon hover"
                          className="absolute inset-0 w-full h-full hidden group-hover:block"
                        />
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-6 md:mt-10">
          <a className="w-full md:w-auto" href={`/${currentLanguage}/services`}>
            <button className="bg-[#B31F11] text-white md:w-[136px] w-full h-[44px] rounded">
              More Info
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Services;
